import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialVideoFolderState } from '..';
import { updateEmbedStatus, updateProjectAsync, updateProjectHostingId } from '../../actions';
import { findAndUpdateProject } from '../../helpers';
import { VideoFolderActions } from '../../types';

const updateProjectReducer: Reducer<typeof initialVideoFolderState, VideoFolderActions> = (
  state = initialVideoFolderState,
  action
) => {
  switch (action.type) {
    case getType(updateEmbedStatus): {
      const { embed, projectIds } = action.payload;

      const newData = findAndUpdateProject(
        state.data!,
        projectIds
      )(v => ({
        ...v,
        isEmbedded: embed
      }));

      return {
        ...state,
        data: newData
      };
    }
    case getType(updateProjectHostingId): {
      const { hostId, projectId } = action.payload;

      return {
        ...state,
        data: findAndUpdateProject(
          state.data!,
          projectId
        )(v => ({
          ...v,
          extra: {
            ...v.extra,
            hostingId: hostId
          }
        }))
      };
    }

    case getType(updateProjectAsync.request): {
      return {
        ...state,
        updateProject: {
          ...state.updateProject,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(updateProjectAsync.success): {
      const newProjectsPartial = action.payload;
      const projectsIds = newProjectsPartial.map(({ id }) => id);

      return {
        ...state,
        data: findAndUpdateProject(
          state.data!,
          projectsIds
        )(oldProject => ({
          ...oldProject,
          ...newProjectsPartial.find(({ id }) => id === oldProject.id)
        })),

        updateProject: {
          ...state.updateProject,
          isPending: false
        }
      };
    }
    case getType(updateProjectAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        updateProject: {
          ...state.updateProject,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default updateProjectReducer;
